function checkWeek(now) {
    const diaSemana = now.getDay();
    return diaSemana >= 1 && diaSemana <= 5;
}

// Función para actualizar la cuenta regresiva cada segundo
function updateCountdown(cutOffTime) {
    const now = new Date();
    let timeDifference = cutOffTime.getTime() - now.getTime();
    timeDifference = Math.max(timeDifference, 0);
    const horasFaltantes = Math.floor(timeDifference / (1000 * 60 * 60));
    const minutosFaltantes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const segundosFaltantes = Math.floor((timeDifference % (1000 * 60)) / 1000);

    document.getElementById("delivery-message").innerHTML = "Si compras ahora tu pedido llegará hoy.<br> Compra dentro de <span class='remaining-time'>" + Math.abs(horasFaltantes) + " horas, " + Math.abs(minutosFaltantes) + " minutos, y " + Math.abs(segundosFaltantes) + " segundos";
}

function deliveryMessage() {
    const now = new Date();
    const cutOffTime = new Date();
    cutOffTime.setHours(13);
    cutOffTime.setMinutes(0);
    cutOffTime.setSeconds(0);

    if (checkWeek(now)) {
        if (now.getDay() === 5 && now.getTime() > cutOffTime.getTime()) {
            document.getElementById("delivery-message").innerHTML = 'Si compras hoy tu pedido llegará el día <span class="remaining-time">Lunes</span>';
            console.log('Es viernes, pero se pasó la hora de corte.' + ' Hoy es el día nº ' + now.getDay())

        } else if (now.getDay() === 1,2,3,4,5 && now.getTime() < cutOffTime.getTime()) {
            updateCountdown(cutOffTime);
            setInterval(() => updateCountdown(cutOffTime), 1000);
            document.getElementById("delivery-message").innerHTML = "Si compras ahora tu pedido llegará hoy.<br> Compra dentro de <span class='remaining-time'>" + Math.abs(horasFaltantes) + " horas, " + Math.abs(minutosFaltantes) + " minutos, y " + Math.abs(segundosFaltantes) + " segundos";
            console.log('Sí se cumplen las condiciones para el despacho el mismo día. Dia Laboral (entre Lunes y Viernes, antes de las 12' + ' Hoy es el día nº ' + now.getDay())
        } else {
            console.log('Es día Laboral y ya pasó la hora de corte' + ' Hoy es el día nº ' + now.getDay())
            document.getElementById("delivery-message").innerHTML = 'Si compras hoy tu pedido llega <span class="remaining-time">mañana</span>';
        }
    } else {
        console.log('Es fin de semana, la regla genera que se despache el próximo Lunes.' + ' Hoy es el día nº ' + now.getDay())
        document.getElementById("delivery-message").innerHTML = 'Si compras hoy tu pedido llegará el <span class="remaining-time">Lunes</span>';
    }
}

deliveryMessage();

